export default {
  'turbolinks:load': [],
  'turbolinks:before-cache': []
};
